import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { TutorProfile, UpdateTutorDto } from "src/app/_models/Tutor";
import { Userprofile } from "src/app/_models/Userprofile";
import { TutorEditActionTypes } from "src/app/constants/StoreConstants";

export const SetTutorProfile = createAction(
  TutorEditActionTypes.SetTutorProfile,
  props<{tutorProfile: TutorProfile}>(),
);
  
export const LoadTutorProfileSuccess = createAction(
  TutorEditActionTypes.LoadTutorProfileSuccess,
  props<{userProfile: Userprofile}>()
);
  
export const SetTutorProfileSuccess = createAction(
  TutorEditActionTypes.SetTutorProfileSuccess
);
  
export const IsTutorProfileStored = createAction(
  TutorEditActionTypes.IsTutorProfileStored,
  props<{isTutorStored: boolean}>()
);

export const GetIfAllowedToEditTutor = createAction(
  TutorEditActionTypes.GetIfAllowedToEditTutor,
  props<{ selectedTutorId: number }>()
);

export const GetIfAllowedToEditTutorSuccess = createAction(
  TutorEditActionTypes.GetIfAllowedToEditTutorSuccess,
  props<{ result: boolean }>()
);

export const GetIfAllowedToEditTutorError = createAction(
  TutorEditActionTypes.GetIfAllowedToEditTutorError,
  props<{ error: any }>()
);

export const ResetCheckIfAllowedToEditTutor = createAction(
  TutorEditActionTypes.ResetCheckIfAllowedToEditTutor
);

export const UpdateTutor = createAction(
  TutorEditActionTypes.UpdateTutor,
  props<{ updateTutorDto: UpdateTutorDto }>()
);

export const UpdateTutorSuccess = createAction(
  TutorEditActionTypes.UpdateTutorSuccess,
  props<{ result: Userprofile }>()
);

export const UpdateTutorError = createAction(
  TutorEditActionTypes.UpdateTutorError,
  props<{ updateTutorError: HttpErrorResponse }>()
);

export const ResetTutorUpdateProps = createAction(
  TutorEditActionTypes.ResetTutorUpdateProps
);